import { render, staticRenderFns } from "./tab.vue?vue&type=template&id=5398ee96&"
import script from "./tab.vue?vue&type=script&lang=js&"
export * from "./tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5398ee96')) {
      api.createRecord('5398ee96', component.options)
    } else {
      api.reload('5398ee96', component.options)
    }
    module.hot.accept("./tab.vue?vue&type=template&id=5398ee96&", function () {
      api.rerender('5398ee96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/fee/views/new_fee/discount_fee_manage/form/components/tab.vue"
export default component.exports